/**
 * useToast Composable
 * 토스트 메시지 관리
 */

import { ref } from 'vue'
import type { ToastItem } from '@/components/common/Toast.vue'

const toasts = ref<ToastItem[]>([])
let toastIdCounter = 0

export function useToast() {
  const add = (
    type: ToastItem['type'],
    message: string,
    duration: number = 3000
  ) => {
    const id = `toast-${++toastIdCounter}`

    const toast: ToastItem = {
      id,
      type,
      message,
      duration
    }

    // E26(2026-10-13): 토스트가 2개씩 겹쳐 헤더를 가렸다 — 한 번에 하나(같은 문구 연타도 하나)만 보인다
    toasts.value.splice(0, toasts.value.length, toast)

    // 자동 제거
    if (duration > 0) {
      setTimeout(() => {
        remove(id)
      }, duration)
    }

    return id
  }

  const remove = (id: string) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index !== -1) {
      toasts.value.splice(index, 1)
    }
  }

  const success = (message: string, duration?: number) => {
    return add('success', message, duration)
  }

  const error = (message: string, duration?: number) => {
    return add('error', message, duration)
  }

  const warning = (message: string, duration?: number) => {
    return add('warning', message, duration)
  }

  const info = (message: string, duration?: number) => {
    return add('info', message, duration)
  }

  const clear = () => {
    toasts.value = []
  }

  return {
    toasts,
    add,
    remove,
    success,
    error,
    warning,
    info,
    clear
  }
}
